// extracted by mini-css-extract-plugin
export var cartContainer = "_jo-4";
export var gray = "_jo-1";
export var itemContainer = "_jo-2";
export var itemDetails = "_jo-3";
export var strong = "_jo-0";